import React from "react";
import PropTypes from "prop-types";

import BaseSkeleton from "components/Skeleton/BaseSkeleton";
import { SkeletonRoot, SkeletonRow } from "./styled";

export default function FaqSkeleton({ rows }) {
  return (
    <SkeletonRoot>
      {Array.from({ length: rows }).map((_, index) => (
        <SkeletonRow key={index}>
          <BaseSkeleton height={22} width={index % 2 === 0 ? "62%" : "54%"} />
          <BaseSkeleton height={16} width="92%" />
          <BaseSkeleton height={16} width={index % 2 === 0 ? "84%" : "76%"} />
        </SkeletonRow>
      ))}
    </SkeletonRoot>
  );
}

FaqSkeleton.propTypes = {
  rows: PropTypes.number,
};

FaqSkeleton.defaultProps = {
  rows: 5,
};
